import sortSearch from './sortSearchClient';

const findOrderFavorites = (
  a,
  b,
  rates_a,
  rates_b,
  provider_priority_a,
  provider_priority_b
) => {
  const providerDiff = (provider_priority_a || 0) - (provider_priority_b || 0);

  if (providerDiff !== 0) {
    return providerDiff;
  }

  const priority_a = +a.priority || 0;
  const priority_b = +b.priority || 0;

  const price_a =
    Number.parseFloat(rates_a?.price?.details_USD?.total) || Infinity;
  const price_b =
    Number.parseFloat(rates_b?.price?.details_USD?.total) || Infinity;

  if (price_a === price_b) {
    return priority_a - priority_b;
  }

  return price_a - price_b;
};

export default function sortFavoritesClient(hotels, providers_priority) {
  return sortSearch(hotels, findOrderFavorites, providers_priority);
}
